<template>
  <div>
    <img
      src="../../assets/banner_2025.jpg"
      alt=""
      style="width: 100%; margin-bottom: 50px;margin-top: 50px"
    />
    <h1 class="title_second">2025 “Dunhuang Cup” Chinese Instrumental Music Performance Competition</h1>
    <h1 class="title_second">Regulations for the North America Division</h1>
    <!-- <h1 class="title_first">活动章程</h1> -->
    <div class="constitution">
      <p style="margin-bottom: 24px"></p>
      <p>Promoting Chinese culture, so that the world can understand China.</p>
      <p>
        The “Dunhuang Cup” Chinese Instrumental Music Performance Competition (North America Division) will be held in Vancouver, Canada, in December 2025.Building on the tradition of the erhu competition, this event will, for the first time, include instruments such as pipa and guzheng as official competition categories in the North America Division.This marks a further improvement of the “Dunhuang Cup” competition system in North America, opening a broader stage for the development and dissemination of Chinese traditional music overseas.
      </p>
      <p>
        The North America Division of the “Dunhuang Cup” will align with international top-level music competition standards, while considering local realities to scientifically organize the event.This will enhance the global recognition of Chinese traditional instruments.The addition of new competition categories not only enriches the content of the event, but also provides a more comprehensive platform for musicians in North America to showcase their talents.
      </p>
      <p>
        Since its establishment in 2010, the “Dunhuang Cup” series of elite showcases and competitions has attracted an increasing number of professional and amateur learners.With authoritative judging panels, rigorous rules, and diverse academic activities, it has gradually gained recognition from professionals and global enthusiasts of Chinese music.It has become an influential brand in the field of Chinese instrumental music competitions.In recent years, international divisions have also been established in Japan and Singapore, operating independently in accordance with international music competition standards and achieving positive social impact.The inclusion of multiple traditional instruments in the North America Division will further promote the diversified development of Chinese music on the international stage.
      </p>
      <div class="key_point">
        <span class="bc_red">I. Event Organizing Institutions</span>
        <br />
        <span class="bold">Co-organizers:</span>China Musical Instrument Association
        <p class="content">
          Organizing Committee of the “Dunhuang Cup” Chinese National Instrumental Music Competition
          <br />
          Shanghai No.1 National Musical Instrument Factory Co., Ltd.
          <br />
          Canada Y.C. Chinese Music Association
          <br />
          American International Performing Arts Friendship Association
          <br />
          Beijing Huaxia Xuanyin Art Communication Center
          <br />
        </p>
        <span class="bold">Organizer of the North America Division:</span>Canada Y.C. Music Academy
      </div>
      <!-- <div class="key_point">
        <span class="bc_red">二、活动组委会</span>
          <br>
        <span class="bold">组委会主任：</span>孙瑞勇（中国乐器协会副理事长）
          <br>
        <span class="bold">组委会副主任：</span><span class="small">（按姓氏笔划排序）</span>
          <br>
        王国振（上海民族乐器一厂有限公司总经理）
          <br>
        刘 勇 （中国乐器协会秘书长）
          <br>
        杜怡璇（北京华夏璇音艺术传播中心总经理）
          <br>
        林汉崇（新加坡南洋艺术学院音乐学院院长）
          <br>
        杨忠才（加拿大英才音乐学院院长）
          <br>
        武乐群 （NOP日本二胡振兴会理事长）
          <br>
        费维耀（上海音乐出版社、上海文艺音像电子出版社社长，总编辑）
          <br>
        <span class="bold">组委会秘书长：</span>杜怡璇
      </div> -->
      <div class="key_point">
        <span class="bc_red">II. Jury Committee of the North America Division</span>
        <br />
        <span class="bold">Honorary Chairman of the Jury Committee:</span>
        <br />
        Liu Changfu: Renowned erhu performer and educator, senior erhu tutor and professor at the Central Conservatory of Music, Director of the Advisory Committee of the Erhu Society of the Chinese Musicians Association, Vice President of the Liu Tianhua Research Association of the Chinese Musicians Association, and Honorary President of the Huqin Professional Committee of the Chinese National Orchestral Society.
        <br />
        <span class="bold">Chairman of the Jury Committee:</span>
        Yang Zhongcai: President of Canada Y.C. Music Academy (Vancouver).
        <br />
        <span class="bold">Vice Chairmen of the Jury Committee :</span
        ><span class="small">(in the order of surname strokes)</span>
        <br />
        You Hui: Guzheng Professor at Stanford University (USA), Artistic Director of the Stanford Guzheng Ensemble and the Chinese Music Orchestra.
        <br />
        Li Yang: President of the Montreal Huqin Research Association, Artistic Director of the Montreal National Chamber Orchestra.
        <br />
        Liu Yang: Renowned erhu performer based in North America, Professor and Head of the Strings Department at Canada Y.C. Music Academy.
        <br />
        Liu Guilian: Professor and Head of the Plucked Strings Department at Canada Y.C. Music Academy.
        <br />
        Chen Wenying: Vice President of Canada Y.C. Music Academy, Professor and Leading Scholar of the Guzheng Program.
        <br />
        Chen Jiebin: Renowned erhu performer based in North America, First-Class Performer.
        <br />
        Chen Guochan: President of the Toronto Chinese Music Academy (Canada).
        <br />
        Gao Hong: Pipa performer and composer, Grammy voting member, Artistic Director of the World Music Orchestra and Chinese Music Ensemble at Carleton College (USA).
        <br />
        <span class="bold">Executive Director of the Jury:</span>
        <br />
        He Xiaomei: Pipa performer, President of the Toronto Chinese Music Academy (Canada)
        <br />
        <span class="bold">Secretaries-General of the Jury Committee:</span>
        <br />
        Bai Xue: Concertmaster of the Canada-China National Orchestra.
        <br />
        Nan Feihong: Staff member at the Office of the President, University of Toronto (Canada).
        <br />
        <span class="ban"
          >Expert Jury Members: For the sake of fairness, the specific list of expert jury members will not be published at this time.</span
        >
      </div>
      <div class="key_point">
        <span class="bc_red">III. Competition Regulations</span>
        <br />
        <span class="bold">Competition Categories:</span>
        <br />
        <span class="bc_red">Solo Categories</span>
        <br />
        <span class="red bold">1. Bowed Strings</span>
        <br />
        Erhu, Gaohu, Zhonghu, Banhu, Jinghu, and other traditional Chinese bowed instruments.
        <br />
        <span class="red bold">2. Plucked Strings</span>
        <br />
        Pipa, Guzheng, Yangqin, Ruan, and other traditional Chinese plucked instruments.
        <br />
        <span class="red bold">3. Wind Instruments</span>
        <br />
        Dizi, Suona, Sheng, Xiao, and other traditional Chinese wind instruments.
        <br />
        <span class="bc_red">Ensemble Categories</span>
        <br />
        <span class="bold">String Ensemble</span>
        <br />
        Comprising bowed instruments such as Erhu, Gaohu, Zhonghu, Banhu, Jinghu, etc.
        <br />
        <span class="bold">Plucked Strings Ensemble</span>
        <br />
        Comprising plucked instruments such as Pipa, Guzheng, Yangqin, Ruan, etc.
        <br />
        <span class="bold">Wind Ensemble</span>
        <br />
        Comprising wind instruments such as Dizi, Suona, Sheng, Xiao, etc.
        <br />
        <br />
        <span class="bold">Eligibility:</span
        >Learners, enthusiasts, and professional performers of traditional Chinese music living outside mainland China.
        <br />
        <span class="bold">Registration Period:</span>October 1 – December 12
        <br />
        <span class="bold">Preliminary Round</span>December 15
        <br />
        <span class="bold">Final Round:</span>December 29
        <br />
        <span class="red bold">Key Notes:</span>
        <br />
        1. All categories will be judged online via video submissions.
        <br />
        2. The Professional Division includes both preliminary and final rounds.
        <br />
        3. The Non-professional Division includes only the preliminary round (no final).
        <br />
        <span class="bc_red" style="margin-top: 30px">Competition Divisions</span>
        <br />
        (Ages are calculated as of June 30th)
        <br />
        <span class="bc_red">1. Non-professional Division</span>
        <br />
        <span class="bold">Children’s Groups:</span>
        <br />
        Group A: Ages 6–9
        <br />
        Group B: Ages 10–13
        <br />
        Group C: Ages 14–17
        <br />
        <span class="bold">Adult Groups:</span>
        <br />
        Group A: Ages 18–35
        <br />
        Group B: Ages 36–64
        <br />
        Group C: Ages 65 and above
        <br />
        <span class="bc_red">2. Professional Division </span><span class="ban">(limited to those not permanently residing in mainland China)</span>
        <br />
        <span class="bold">Professional Group A:</span>Ages 14–18
        <br />
        Students of professional music conservatories.
        <br />
        <span class="bold">Professional Group B:</span>Ages 19–45
        <br />
        Teachers, students of art institutions, and freelance performers, including foreign national instructors and performers.
        <br />
        <span class="bc_red">3. Ensemble Division</span>
        <br />
        No age restrictions.
        <br />
        <span class="bc_red">Repertoire Guidelines</span>
        <br />
        <span class="red bold">I. Non-professional Solo Division</span>
        <br />
        One self-chosen piece for the entire competition.
        <br />
        The piece must be fully prepared, performed from memory, and without any form of accompaniment.
        <br />
        <span class="red bold">II. Professional Division</span>
        <br />
        <span class="red bold">Four categories: Erhu, Pipa, Guzheng, Zhongruan.</span>
        <br />
        <span class="bold">Preliminary Round: </span>One self-chosen piece.
        <br />
        <span class="bold">Final Round:</span
        >Two pieces selected from the prescribed repertoire, one of which must be traditional or folk style, and not overlapping with the preliminary piece.
        <br />
        <span
          >All pieces must be fully prepared and performed from memory. Preliminary round: no accompaniment allowed. Final round: accompaniment is optional and will not affect scoring.</span
        >
        <br />
        <span class="bc_red">Prescribed Repertoire</span>
        <br />
        <span class="red bold">Erhu Division:</span>
        <br />
        <span class="bold">a. Regional-Style Works</span>
        <br />
        Spring Scenery of Jiangnan (composed by Ma Xilin & Zhu Changyao)
        <br />
        Journey through Henan (composed by Song Guosheng)
        <br />
        Qinqiang Theme Fantasia (arranged by Zhao Zhenxiao & Lu Rirong)
        <br />
        Hometown (composed by Liu Changfu)
        <br />
        New Herdsmen on the Grassland (composed by Liu Changfu)
        <br />
        Spring Sunshine (composed by Lu Jianmin)
        <br />
        Song on the Mountain Ridge (composed by Wang Xu)
        <br />
        <span class="bold">b. Traditional Classics</span>
        <br />
        Moonlit Night (composed by Liu Tianhua)
        <br />
        Listening to the Pines (composed by Hua Yanjun)
        <br />
        The River Runs Red (Northeastern folk tune, adapted by Huang Huaihai)
        <br />
        Autumn Moon over the Han Palace (ancient piece)
        <br />
        <span class="bold">c. Contemporary Masterpieces</span>
        <br />
        Erhu Rhapsody No. 5 (composed by Wang Jianmin)
        <br />
        Amannisha (composed by Wang Danhong)
        <br />
        Ode to Chu (composed by Li Bochan)
        <br />
        Original Aspiration (composed by Li Bochan)
        <br />
        Spirit of the Snow Mountain (composed by Liu Wenjin)
        <br />
        Erhu Concerto No. 2 – Pursuing Dreams in Beijing (composed by Guan Naizhong)
        <br />
        <span class="red bold">Pipa Division:</span>
        <br />
        <span class="bold">a. Regional-Style Works</span>
        <br />
        Two Sisters on the Grassland (solo version, composed by Liu Dehai & Wu Zuqiang)
        <br />
        Dance of Kucha (composed by Yang Jing)
        <br />
        Yi Ethnic Dance (arranged by Wang Huiran)
        <br />
        March in Jiangnan (composed by Wang Huiran)
        <br />
        Dance of the Mountain (composed by Chen Yin)
        <br />
        Melody of the Xianzi (composed by Tang Liangxing)
        <br />
        <span class="bold">Traditional Classics</span>
        <br />
        Wild Geese Descending on the Sandbank
        <br />
        Song of the Frontier (including Shen Haochu’s transmitted score Thinking of Spring)
        <br />
        Xu Lai (composed by Liu Tianhua)
        <br />
        Improved Exercise (composed by Liu Tianhua)
        <br />
        Chen Xingyuan Marries into the Fan Kingdom (arr. by Lin Shicheng)
        <br />
        Ancient Tune of Yingzhou (performance duration no less than 5 minutes)
        <br />
        <span class="bold">c. Contemporary Masterpieces</span>
        <br />
        The Six Steeds of Zhao Mausoleum (composed by Liu Dehai)
        <br />
        Short Sword and Bronze Armor (composed by Chen Danbu)
        <br />
        Late Autumn (composed by Li Bochan)
        <br />
        Lament—Inspired by Bai Juyi’s “Song of the Pipa” (composed by Wu Houyuan)
        <br />
        Clouds Dream of Flowers (composed by Wang Danhong)
        <br />
        Spring Silkworms (composed by Liu Dehai)
        <br />
        The Swan (composed by Liu Dehai)
        <br />
        <span class="red bold">Guzheng Division:</span>
        <br />
        Three Variations on Plum Blossoms
        <br />
        By the Ili River (composed by Cheng Gongliang)
        <br />
        Late Sunshine (composed by Deng Yiqun)
        <br />
        Lotus Blossoms in the Rain (composed by Wang Rui)
        <br />
        Ode to Guizhou (composed by Xu Xiaolin)
        <br />
        The Scholar (composed by Fang Rongqing)
        <br />
        Rippling Waves (composed by Tao Yimo)
        <br />
        Forest Spring (composed by Ye Xiaogang)
        <br />
        Chasing the Sun (composed by Chen Zhe)
        <br />
        Soundscape of Yunnan Mountains (composed by Wang Zhongshan)
        <br />
        Gazing at Qin Chuan (composed by Jing Jianshu & Wang Zhongshan)
        <br />
        Mooring by Maple Bridge at Night (composed by Wang Jianmin)
        <br />
        Cang Ge Yin (composed by Chen Zhe)
        <br />
        Cloud Garment Lament (composed by Zhou Yuguo)
        <br />
        The Hegemon-King of Western Chu (composed by He Zhanhao)
        <br />
        Song of Wind and Waves (composed by Deng Yiqun)
        <br />
        Morning Mist (composed by Wang Zhongshan)
        <br />
        Melody of Sheng and Xiao (composed by Zhuang Yao)
        <br />
        Hunt of the Wind (composed by Tao Yimo)
        <br />
        The Traveler (composed by Wei Jun)
        <br />
        Western Themes Fantasia (composed by Huang Qiuyu & Zhou Wang)
        <br />
        <span class="red bold">Zhongruan Division:</span>
        <br />
        Camel Bells along the Silk Road (composed by Ning Yong)
        <br />
        Distant Song (composed by Chen Wenjie)
        <br />
        Longing (composed by Lin Jiliang)
        <br />
        Grassland Sentiment (composed by Lin Jiliang)
        <br />
        Full River Red (composed by Lin Jiliang)
        <br />
        Tour of Mount Tai (composed by Lin Jiliang)
        <br />
        Under the Grapevine (composed by Lin Jiliang)
        <br />
        Night of the Torch Festival (composed by Wu Junsheng)
        <br />
        Mountain Resonance II – Stream (composed by Zhou Yuguo)
        <br />
        Blooming (performed by Zheng Cuiping, composed by Su Wenqing)
        <br />
        Mountain Song (composed by Liu Xing)
        <br />
        Improvisation (composed by Liu Xing)
        <br />
        Solitary Elegance (composed by Liu Xing)
        <br />
        Memories of Yunnan, Movement I (composed by Liu Xing)
        <br />
        Memories of Yunnan, Movement III (composed by Liu Xing)
        <br />
        The Taste Remains, Movement I (composed by Wen Zhanli)
        <br />
        <span class="red bold">III. Ensemble Division</span>
        <br />
        Each ensemble must perform one self-chosen piece for the entire competition (no accompaniment).
        <br />
        Each ensemble must consist of 4-16 performers; repertoire and performance style are not restricted.The performance length should be between 3–8 minutes.The piece must include at least two independent parts; unison or single-voice performances are not accepted for this competition.
      </div>
      <div class="key_point">
        <span class="bc_red">IV. Competition Method</span>
        <br />
        <span class="bold">(1) Registration and Preliminary Round</span>
        <br />
        1. Online registration: Please follow the WeChat public account “Canada Y.C. Music Exchange” for competition information.From October 1 to December 12, please log on to the official competition website www.canadaecc.cn<router-link
          to="login"
          >
          <!-- <span class="clickToGoIn">点击进入</span> -->
          </router-link
        ><router-link to="finalresult"
          ><img
            class="register_entry"
            src="../../assets/search_entry.jpg"
            alt="" /></router-link
        > to complete the online registration and pay the preliminary review fee.After completing the registration, upload the preliminary round video. Each video file should be named using the participant’s name + group.When filling out the online registration form, please double-check carefully. The name must match the identification document, and one contact phone number may only be used to register one participant.(Deadline for submission of preliminary round videos: December 12 at the latest)
        2. Paper form registration: <a href="/Public/Form/2025_Registration_Form.pdf" download>RegistrationForm</a>
        <br />
        Registration inquiry phone: +1 (604) 278-7730
        <br />
        Please scan the QR code below to follow the Organizing Committee’s WeChat public account in order to receive the latest competition updates in a timely manner. For competition inquiries, please contact via WeChat: canadaycmusicacademy.
        <br />
        <img src="../../assets/code.png" alt="" />&nbsp;
        <img src="../../assets/code_canadaycmusicacademy.png" alt="" />
        <br />
        2. The competition will be conducted entirely through judges reviewing the participants’ video recordings.
        <br />
        <span class="bold">Video Requirements</span>
        <div style="margin-left: 2em">
          a. The performer should be in a well-lit area, facing the camera directly, with an appropriate distance to ensure clear visibility of the performance.
          <br />
          b. The video file name must use the participant’s name and group.
          <br />
          c. The video must not contain artistic editing, such as image or audio splicing. It must be a live recording with strict audio-video synchronization.
          <br />
          d. The video file format must be MP4, with a resolution of either 1280×720p or 720×576p. 
          <br />
          e. Submitted video materials will not be returned.
          <br />
        </div>
        3. Preliminary review fee: Solo category – CAD $80 per person; Ensemble category – CAD $25 per person.
        <br />
        4. Once the Organizing Committee has received all participant materials and fees, confirmation of successful registration will be sent by email.
        <br />
        5. Around December 15, 2025, the preliminary results will be published on the WeChat public account “Canada Y.C. Music Exchange” and the official event website www.canadaecc.cn.
        <br />
        <span class="bold">(2) Final Round </span>
        <br />
        Participants in the Professional Division who advance to the finals must complete the next stage of registration online between December 20 and December 27, following the same procedure as the preliminary round.Contestants who do not advance will not be notified, and submitted materials and review fees will not be refunded.
        <br />
        <span class="bold">Final Round Dates:  </span>December 29, 2025
        <br />
        <span class="bold">Final Review Fee: </span> CAD $120 per person
      </div>
      <div class="key_point">
        <span class="bc_red">V. Awards</span>
        <br />
        1. Each category will include Gold, Silver, Bronze, Outstanding Performance, and Excellence Awards.
        <br />
        2. The Organizing Committee will present the “Outstanding Instructor Award” to teachers whose students win Gold or Silver prizes, as well as to teachers with multiple students advancing to the finals.
        <br />
        3. Prizes and Bonuses:
        <br />
        Special Jury Award
        <br />
        Erhu Division: The participant with the highest overall score in the Non-professional Division and the participant with the highest overall score in the Professional Division will each receive a premium “Dunhuang” brand instrument.
        <br />
        Other Divisions: Based on the final scores by the jury, two winners will be selected from among the plucked-string and wind-instrument solo categories, as well as the ensemble category, to receive the “Special Jury Award.” Each will be awarded CAD $300.
        <br />
        All winners will receive a beautifully designed award certificate.
      </div>
      <div class="key_point">
        <span class="bc_red">VI. Important Notes</span>
        <br />
        1. Once participants register for the competition, it indicates their acceptance of this regulation, and therefore they must comply with all its provisions.
        <br />
        2. The entire registration and participation process is electronic. Award certificates will be printed according to the registration information. When filling out the online registration form, please check carefully to ensure the name matches the identification document. Each contact phone number may only be used to register one participant. Any losses due to errors in the form are the sole responsibility of the applicant.
        <br />
        3. The Organizing Committee reserves the rights to broadcast, televise, use, publish, and distribute the audio and video materials of this competition within the scope of performance rights. Award winners are obliged to participate in charity or outreach performances arranged by the Organizing Committee.
        <br />
        4. Review fees will not be refunded if a participant fails to attend the competition due to personal reasons.
        <br />
        5. Each participant must submit an individual video file; multiple participants may not be recorded in the same video file.
        <br />
        6. In case of cancellation or postponement due to force majeure, the Organizing Committee will announce relevant information on the official website.
        <br />
        Note: The right of final interpretation of this regulation belongs to the Organizing Committee of this event.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}
p {
  text-indent: 2em;
  text-align: justify;
  margin: 4px 0;
  line-height: 30px;
}
pre {
  font-size: 16px;
}
.title_first {
  font-size: 28px;
  color: #c0504d;
  text-align: center;
}
.title_second {
  font-size: 22px;
  color: #c0504d;
  text-align: center;
}
.constitution {
  width: 95%;
  margin: 0 auto;
}
.key_point {
  margin: 30px 0;
  text-align: justify;
  line-height: 30px;
}
.key_point span {
  display: inline-block;
}
.key_point img {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.key_point .bc_red {
  display: inline-block;
  font-size: 18px;
  background-color: #c0504d;
  color: white;
  margin-bottom: 3px;
  font-weight: bold;
}
.key_point .bold {
  font-weight: bold;
}
.key_point .small {
  font-size: 12px;
}
.key_point .ban {
  color: #ccc;
}
.key_point .red {
  color: #c0504d;
  font-weight: bold;
}
.key_point .center {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
.key_point .content {
  text-indent: 0;
  margin-left: 7em;
  margin-top: 0;
}
.key_point .register_entry {
  width: 200px;
  position: fixed;
  bottom: 0;
  left: 100%;
  transform: translateX(-100%);
  z-index: 2;
}
.clickToGoIn {
  font-size: 26px;
  color: red;
  font-weight: bold;
}
</style>
